import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import Input from '../../../../../FormComponents/Input'
import CurrencyField from '../../../../../FormComponents/CurrencyField'
import { currencyUnit } from '../../../../../../utils/Helper'

export default observer(function ShowAll({ provider }) {
  const { selectedScenario, campaign } = useContext(CampaignContext)
  const actions = selectedScenario?.actions.filter(action => action.visible_in_budget)

  const providerActions = useMemo(() => actions.filter(action => action.provider === provider), [provider, selectedScenario, selectedScenario?.actions])
  const influencerCount = useMemo(() => [...new Set(providerActions.map(action => action.authentication_id))].length, providerActions)
  const grossReach = useMemo(() => providerActions.reduce((result, action) => result + action.reach, 0), providerActions)
  const netReach = useMemo(() => providerActions.reduce((result, action) => result + action.action_insight?.reach, 0), providerActions)
  const impression = useMemo(() => providerActions.reduce((result, action) => result + (action.action_insight?.impressions || action?.action_insight?.story_first_sequence_impressions || 0), 0))
  const totalAdvertiserPrice = useMemo(() => providerActions.reduce((result, action) => result + action.totalAdvertiserPrice, 0), providerActions)

  return (
    <div className="mb-8">
      <table className="w-full border-1 border-gray-100 rounded-lg">
        <thead>
          <tr>
            <th className="w-1/3 border-1 border-gray-100 bg-gray-100"></th>
            <th className="w-1/3 border-1 border-gray-100 bg-gray-100 text-left font-normal py-4">Actual</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Amount of influencers</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                disabled
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                value={influencerCount}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Amount of uploads</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                disabled
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                value={providerActions.length}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Gross reach</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                disabled
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                value={grossReach}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Net reach</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                disabled
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                value={netReach}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Impressions</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                disabled
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={0}
                valueIsNumericString={true}
                value={impression}
              />
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-4 border-1 border-gray-100">Influencer budget</td>
            <td className="border-1 border-gray-100 p-4 align-middle">
              <CurrencyField
                topMargin=''
                disabled
                addon={currencyUnit(campaign.currency)}
                thousandSeparator='.'
                decimalSeparator=','
                decimalScale={2}
                fixedDecimalScale={true}
                valueIsNumericString={true}
                value={totalAdvertiserPrice?.toFixed(2)}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
})